import React from "react"

import AppLayout from "./app"

export default ({ children, pageContext }) => (pageContext.layout === "app" ? <AppLayout>{children}</AppLayout> : <>{children}</>)
